// extracted by mini-css-extract-plugin
export var divider = "_td-0";
export var systemMessage = "_td-1";